import { render } from "./TacticalServiceWidget.vue?vue&type=template&id=1e8147d3&scoped=true"
import script from "./TacticalServiceWidget.vue?vue&type=script&lang=js"
export * from "./TacticalServiceWidget.vue?vue&type=script&lang=js"

import "./TacticalServiceWidget.vue?vue&type=style&index=0&id=1e8147d3&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8147d3"]])

export default __exports__